import { render, staticRenderFns } from "./messenger.vue?vue&type=template&id=10cadd23&scoped=true"
import script from "./messenger.vue?vue&type=script&lang=js"
export * from "./messenger.vue?vue&type=script&lang=js"
import style0 from "./messenger.vue?vue&type=style&index=0&id=10cadd23&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cadd23",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10cadd23')) {
      api.createRecord('10cadd23', component.options)
    } else {
      api.reload('10cadd23', component.options)
    }
    module.hot.accept("./messenger.vue?vue&type=template&id=10cadd23&scoped=true", function () {
      api.rerender('10cadd23', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/agent-messages/messenger.vue"
export default component.exports